import React from 'react';
import Spinner from 'react-bootstrap/Spinner';

const Loading = () => {
  return (
    <div className='loading position-absolute'>
      <Spinner animation='border' />
    </div>
  );
};

export default Loading;
